/**
 * 格式化图片
 * @param url 图片地址
 * @param type 格式化后缀,不传默认scale
 */
export function formatImage(url: string, type?: 'scale' | 'square' | 'mark') {
  let formatUrl = '';
  let formatType = type || 'scale';
  if (url && typeof url == 'string' && url.indexOf('qlogo.cn') == -1) {
    let questionMarkIndex = url.lastIndexOf('?') == -1 ? url.length : url.lastIndexOf('?');
    formatUrl = url.slice(0, questionMarkIndex) + `/${formatType}` + url.slice(questionMarkIndex);
  } else {
    formatUrl = url;
  }
  return formatUrl;
}